import { Tabs, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { TransactionHistoryDetails } from "@/modules/finances/transactions/components/transactionHistoryDetails"
import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { TransactionInvoiceLayout } from "@modules/finances/components/transactionInvoiceLayout"
import { TransactionDetailsEntity } from "@modules/finances/entities/transactionDetailsEntity"
import { ApiFinanceType } from "@modules/finances/types/financesType"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { Activity, startTransition, Suspense } from "react"

type TransactionDetailsProps = {
  transactionDetails: TransactionDetailsEntity
  apiFinanceType: ApiFinanceType
  className?: string
} & React.ComponentProps<"div">

export function TransactionDetailsContainer({
  transactionDetails,
  apiFinanceType,
  className,
}: TransactionDetailsProps) {
  const { getCurrentStackState, setCurrentStackState } = useSidebar()
  const activeTabIndex = getCurrentStackState("activeTabIndex") ?? "0"

  const isTransactionVisible = transactionDetails.user !== null

  function selectTab(index: string) {
    startTransition(() => {
      setCurrentStackState("activeTabIndex", index.toString())
    })
  }

  return (
    <div className={cn("mt-2 flex flex-col", className)}>
      <Tabs defaultValue={activeTabIndex} className="relative flex w-full flex-col">
        <TabsList variant="default">
          <TabsTrigger variant="default" onClick={() => selectTab("0")} value="0">
            {word("finances.invoice")}
          </TabsTrigger>
          {isTransactionVisible && (
            <TabsTrigger variant="default" onClick={() => selectTab("1")} value="1">
              {word("finances.history")}
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>

      <Activity mode={activeTabIndex === "0" ? "visible" : "hidden"}>
        <Suspense fallback={<LoadingSpinner />}>
          <TransactionInvoiceLayout
            transactionDetails={transactionDetails}
            className="px-5"
            apiFinanceType={apiFinanceType}
          />
        </Suspense>
      </Activity>

      {isTransactionVisible && transactionDetails.user && (
        <Activity mode={activeTabIndex === "1" ? "visible" : "hidden"}>
          <Suspense fallback={<LoadingSpinner className="mt-26" />}>
            <TransactionHistoryDetails
              stripeCustomerId={transactionDetails.user.stripeCustomerId}
              apiFinanceType={apiFinanceType}
              className="px-5"
            />
          </Suspense>
        </Activity>
      )}
    </div>
  )
}
